import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the deposit report view.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the datatable for the deposit report.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'Date', // Column ID
                    header: _('Fecha'), // Column header with localization
                    fillspace: 0, // Fill space setting
                    minWidth: 0, // Minimum width
                    width: 200, // Fixed width
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date format for display
                },
                { id: 'Hour', header: _('Hora'), width: 200, sort: 'int' }, // Hour column
                {
                    id: 'NoTicket',
                    header: _('No. Ticket'),
                    width: 150,
                    sort: 'int',
                }, // Ticket number column
                {
                    id: 'FormaPago1',
                    header: _('Forma Pago 1'),
                    width: 150,
                    sort: 'int',
                }, // Payment method column
                {
                    id: 'PagoBonoTC',
                    header: _('Pago Bono / T.C.'),
                    width: 150,
                    sort: 'int',
                }, // Bonus/TC payment column
                {
                    id: 'ValorEntradasEfectivo',
                    header: _('Valor Entradas Efectivo'),
                    width: 200,
                    sort: 'int',
                }, // Cash entry value column
                {
                    id: 'ValorEntradasBonoTC',
                    header: _('Valor Entradas Bono / T.C.'),
                    width: 200,
                    sort: 'int',
                }, // Bonus/TC entry value column
                {
                    id: 'ValorEntradasTraslados',
                    header: _('Valor Entradas Traslados'),
                    width: 200,
                    sort: 'int',
                }, // Transfer entry value column
                {
                    id: 'ValorEntradasRecargas',
                    header: _('Valor Entradas Recargas'),
                    width: 200,
                    sort: 'int',
                }, // Recharge entry value column
                {
                    id: 'ValorSalidasEfectivo',
                    header: _('Valor Salidas Efectivo'),
                    width: 200,
                    sort: 'int',
                }, // Cash exit value column
                {
                    id: 'ValorSalidasTraslados',
                    header: _('Valor Salidas Traslados'),
                    width: 200,
                    sort: 'int',
                }, // Transfer exit value column
                {
                    id: 'ValorSalidasNotasRetiro',
                    header: _('Valor Salidas Notas de Retiro'),
                    width: 200,
                    sort: 'int',
                }, // Withdrawal note exit value column
                { id: 'Saldo', header: _('Saldo'), width: 150, sort: 'int' }, // Balance column
                { id: 'Moneda', header: _('Moneda'), width: 150, sort: 'int' }, // Currency column
            ],
            footer: true, // Enable footer
            math: true, // Enable mathematical operations in footer
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            // API URL for data fetching
            url: devConfig.geturlApi() + 'es/GetFlujoCaja?FromId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = grid.data.url; // URL for data loading
        var filter = ''; // Filter string for API requests

        // Event listener for filtering data
        this.on(this.app, 'flujoCaja:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string

            // Construct filter string based on filter data
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to filter
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load data with sorting
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id, // Load data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
